import { Component } from "react";

import { ModalLink } from "@app/shared/Modals";
import { QesIcon } from "@app/shared/icons/QESIcon";

interface ArchiveProjectLinkProps {
  archiveDisabled: boolean;
  archiveIcon: string;
  archiveText: string;
  onArchiveConfirm: () => Promise<void>;
}

class ArchiveProjectLink extends Component<ArchiveProjectLinkProps> {

  constructor(props: ArchiveProjectLinkProps) {
    super(props);
  }

  public render() {
    return (
      // This obviously isn't a side-panel-link, but the class styles it like we want
      <ModalLink
        classNames="col-12 action-menu-item side-panel-link fw-normal"
        disabled={this.props.archiveDisabled}
        content={{
          body: `${this.props.archiveText} this project?`,
          cancelButtonText: "Cancel",
          confirmButtonAction: this.props.onArchiveConfirm,
          confirmButtonText: this.props.archiveText,
          confirmButtonType: this.props.archiveText === "Archive" ? "primary-danger" : "primary",
          title: this.props.archiveText,
        }}
        testId="archive-project-modal-link"
      >
        <span className={`project-action-button${this.props.archiveDisabled ? " disabled" : ""}`}>{this.props.archiveIcon ? <QesIcon iconName={this.props.archiveIcon} isDecorative /> : null}{this.props.archiveText}</span>
      </ModalLink>
    );
  }
}

export { ArchiveProjectLink };
